import { Chip } from '@mui/material'

const QuickFilter = ({ label }) => {
  return <Chip sx={{ marginBottom: 1 }} label={label} />
}

export default QuickFilter